import * as React from 'react';
var PageContext = /*#__PURE__*/React.createContext(undefined);
if (false) PageContext.displayName = "PageContext";
if (false) {
  PageContext.displayName = 'PageContext';
}
export default PageContext;